<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <div class="grid grid-cols-12 gap-3 py-5 container">
            <div class="col-span-12 md:col-span-5 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                    {{ $t('name') }}<span class="text-red-500 text-xl">*</span>
                </div>
                <b-form-input v-model="modelForm.name" class="border-gray-300 h-11 focus:ring-0"/>
            </div>

            <div class="col-span-12 md:col-span-4 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                    {{ $t('finance.initialAmount') }}<span class="text-red-500 text-xl">*</span>
                </div>
                <b-form-input v-model="modelForm.balance" type="number" min="0" class="border-gray-300 h-11 focus:ring-0"/>
            </div>

            <div class="col-span-12 md:col-span-3 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                    {{ $t('currency') }}<span class="text-red-500 text-xl">*</span>
                </div>

                <b-form-select
                    v-model="modelForm.balanceCurrency"
                    :options="getCurrencies"
                    value-field="@id"
                    text-field="shortName"
                    class="border-gray-300 h-11 focus:ring-0"
                >
                </b-form-select>
            </div>
        </div>

        <div class="container grid grid-cols-2 gap-3 pb-4">
            <SubmitRow
                sm-size="12"
                md-size="12"
                :isDisabled="modelForm.name === null || modelForm.name === ''"
                :text="submitButtonName"
                :is-loading="isLoading"
                :do-action="addOrEdit"
            />

            <SubmitRow
                v-show="modelForm.name !== ''"
                sm-size="12"
                md-size="12"
                :is-loading="isLoading"
                text="sale.transaction.cancel"
                :do-action="addOrEdit"
            />
        </div>

    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import Row from "../../components/html/Row";
import SubmitRow from "../../components/SubmitRow";
import accessMixin from "../../mixin/accessMixin";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";

export default {
    name: "Add",
    components: {
        SubmitRow,
        Row,
    },
    mixins: [validatorMixin, accessMixin, currencyFormatMixin, dateFormattingMixin, currencyRateMixin],
    data() {
        return {
            submitButtonName: 'save',
            errors: {sum: null},
            isLoading: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'finance.counts', url: 'companyCount'},
                {name: 'add'},
            ],
            modelForm: {
                id: null,
                name: '',
                balance: null,
                balanceCurrency: '/api/currencies/3',
            },
        }
    },
    computed: {
        ...mapGetters([
            'getCompanyCount',
            'getCurrencies',
        ]),
    },
    methods: {
        ...mapActions(['fetchCompanyCount', 'putCompanyCount', 'pushCompanyCount', 'setBreadcrumbItems']),
        addOrEdit() {
            this.isLoading = true

            if (this.$route.name === 'companyCount/add') {
                if(this.modelForm.name !== '') {
                    this.pushCompanyCount({
                        name: this.modelForm.name,
                        balance: this.modelForm.balance === null ? '0.00' : this.modelForm.balance,
                        balanceCurrency: this.modelForm.balance === null ? null : this.modelForm.balanceCurrency,
                    })
                        .then(() => {
                            this.$i18nHelper.toUrl('companyCount')
                        })

                }

                this.isLoading = false
            } else {
                this.putCompanyCount({
                    url: 'company_counts',
                    id: this.modelForm.id,
                    name: this.modelForm.name,
                    balance: this.modelForm.balance,
                    balanceCurrency: this.modelForm.balanceCurrency,
                })
                    .then(() => {
                        this.$i18nHelper.toUrl('companyCount')
                    })
                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            }
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        if (this.$route.name === 'companyCount/edit') {
            this.$root.showOverlay = true
            this.submitButtonName = 'edit'

            this.fetchCompanyCount(this.$route.params.id)
                .then(() => {
                    this.modelForm.id = this.getCompanyCount.id
                    this.modelForm.name = this.getCompanyCount.name
                    this.modelForm.balance = this.getCompanyCount.balance
                    this.modelForm.balanceCurrency = this.getCompanyCount.balanceCurrency['@id']
                    this.$root.showOverlay = false
                })
        }
    },
}
</script>
